// src/index.js

import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import App from './App';
import QuoteBuilder from './components/QuoteBuilder';
import ThankYou from './components/ThankYou'; // Import ThankYou component
import './index.css'; // Include Tailwind CSS

ReactDOM.render(
  <Router>
	<Routes>
	  <Route path="/" element={<App />} />
	  <Route path="/quote-builder" element={<QuoteBuilder />} />
	  <Route path="/thank-you" element={<ThankYou />} /> {/* Add ThankYou route */}
	</Routes>
  </Router>,
  document.getElementById('root')
);
